// extracted by mini-css-extract-plugin
export default {"container":"VideoStudio_container__xU0KC","title":"VideoStudio_title__TriI9","videoWrapper":"VideoStudio_videoWrapper__GsQ2p","video":"VideoStudio_video__mnpwn"};